import React from 'react';
import SectionTabs from '../../components/SectionTabs';
import ManagementApiLogs from './ApiLogs';
import ManagementAuditLog from './AuditLog';

/**
 * Journaux : ce qui s'est passé, côté machine et côté équipe. Onglet « API » :
 * appels reçus, erreurs renvoyées, échecs de connexion ; onglet « Historique »
 * (`?vue=historique`) : les actions sensibles faites depuis le back-office.
 */
const LogsHub = () => (
  <SectionTabs
    ariaLabel="Journal affiché"
    views={[
      { id: 'api', label: 'API', render: () => <ManagementApiLogs /> },
      { id: 'historique', label: 'Historique', render: () => <ManagementAuditLog /> }
    ]}
  />
);

export default LogsHub;
